import { formatPeriodRange } from './format-date-range.js';
/**
 * Names a bank statement by the period it covers: "the statement covering
 * 1 – 31 May 2026", or "the statement covering 15 May 2026" for a statement
 * whose rows all fall on one day.
 *
 * Shared because two surfaces name the same statement in the same sentence:
 * the Bill UI's `period-overlap` finding row and the bookkeeper CLI's
 * `bank-statement` finding line. They are separate apps and must not import
 * each other, so the phrase lives here - previously each held its own copy and
 * each asserted in a comment that the other agreed, which is the claim that
 * rots. Each surface still owns what differs: its legacy fallback wording (the
 * period fields are absent on findings stored before they existed) and whether
 * it appends the statement id.
 *
 * Takes full ISO datetimes as stored on the finding and slices to the
 * `YYYY-MM-DD` head `formatPeriodRange` expects, so no caller repeats the
 * slice.
 */
export function describeStatementPeriodPhrase(startIso, endIso) {
    return `the statement covering ${formatPeriodRange(startIso.slice(0, 10), endIso.slice(0, 10))}`;
}
